@file:OptIn(InternalResourceApi::class)

package subastia.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/subastia.composeapp.generated.resources/"

internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 28),
      ))
    }

internal val Res.string.btn_accept: StringResource by lazy {
      StringResource("string:btn_accept", "btn_accept", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39, 30),
      ))
    }

internal val Res.string.btn_apply_filters: StringResource by lazy {
      StringResource("string:btn_apply_filters", "btn_apply_filters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70, 45),
      ))
    }

internal val Res.string.btn_back: StringResource by lazy {
      StringResource("string:btn_back", "btn_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 116, 24),
      ))
    }

internal val Res.string.btn_close: StringResource by lazy {
      StringResource("string:btn_close", "btn_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141, 25),
      ))
    }

internal val Res.string.btn_filter: StringResource by lazy {
      StringResource("string:btn_filter", "btn_filter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167, 30),
      ))
    }

internal val Res.string.btn_go_to_profile: StringResource by lazy {
      StringResource("string:btn_go_to_profile", "btn_go_to_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198, 53),
      ))
    }

internal val Res.string.btn_google_signin: StringResource by lazy {
      StringResource("string:btn_google_signin", "btn_google_signin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252, 61),
      ))
    }

internal val Res.string.btn_login: StringResource by lazy {
      StringResource("string:btn_login", "btn_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 314, 37),
      ))
    }

internal val Res.string.btn_logout: StringResource by lazy {
      StringResource("string:btn_logout", "btn_logout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 352, 38),
      ))
    }

internal val Res.string.btn_next: StringResource by lazy {
      StringResource("string:btn_next", "btn_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 391, 28),
      ))
    }

internal val Res.string.btn_remove_filter: StringResource by lazy {
      StringResource("string:btn_remove_filter", "btn_remove_filter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 420, 33),
      ))
    }

internal val Res.string.btn_save_search: StringResource by lazy {
      StringResource("string:btn_save_search", "btn_save_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 454, 47),
      ))
    }

internal val Res.string.btn_share: StringResource by lazy {
      StringResource("string:btn_share", "btn_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 502, 29),
      ))
    }

internal val Res.string.btn_signup: StringResource by lazy {
      StringResource("string:btn_signup", "btn_signup", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 532, 34),
      ))
    }

internal val Res.string.btn_start: StringResource by lazy {
      StringResource("string:btn_start", "btn_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 567, 29),
      ))
    }

internal val Res.string.btn_view_boe: StringResource by lazy {
      StringResource("string:btn_view_boe", "btn_view_boe", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 597, 40),
      ))
    }

internal val Res.string.default_saved_search_title: StringResource by lazy {
      StringResource("string:default_saved_search_title", "default_saved_search_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 638, 58),
      ))
    }

internal val Res.string.default_search_title: StringResource by lazy {
      StringResource("string:default_search_title", "default_search_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 697, 40),
      ))
    }

internal val Res.string.desc_ai_verified: StringResource by lazy {
      StringResource("string:desc_ai_verified", "desc_ai_verified", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 738, 28),
      ))
    }

internal val Res.string.desc_delete_search: StringResource by lazy {
      StringResource("string:desc_delete_search", "desc_delete_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 767, 50),
      ))
    }

internal val Res.string.desc_filter_icon: StringResource by lazy {
      StringResource("string:desc_filter_icon", "desc_filter_icon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 818, 36),
      ))
    }

internal val Res.string.desc_location_icon: StringResource by lazy {
      StringResource("string:desc_location_icon", "desc_location_icon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 855, 42),
      ))
    }

internal val Res.string.desc_map_location: StringResource by lazy {
      StringResource("string:desc_map_location", "desc_map_location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 898, 45),
      ))
    }

internal val Res.string.desc_remove_favorite: StringResource by lazy {
      StringResource("string:desc_remove_favorite", "desc_remove_favorite", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 944, 56),
      ))
    }

internal val Res.string.desc_save_search: StringResource by lazy {
      StringResource("string:desc_save_search", "desc_save_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1001, 84),
      ))
    }

internal val Res.string.desc_search_bar: StringResource by lazy {
      StringResource("string:desc_search_bar", "desc_search_bar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1086, 47),
      ))
    }

internal val Res.string.desc_splash_screen_logo: StringResource by lazy {
      StringResource("string:desc_splash_screen_logo", "desc_splash_screen_logo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1134, 63),
      ))
    }

internal val Res.string.desc_toggle_favorite: StringResource by lazy {
      StringResource("string:desc_toggle_favorite", "desc_toggle_favorite", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1198, 52),
      ))
    }

internal val Res.string.empty_favorites_subtitle: StringResource by lazy {
      StringResource("string:empty_favorites_subtitle", "empty_favorites_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1251, 108),
      ))
    }

internal val Res.string.empty_favorites_title: StringResource by lazy {
      StringResource("string:empty_favorites_title", "empty_favorites_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1360, 69),
      ))
    }

internal val Res.string.empty_saved_searches_title: StringResource by lazy {
      StringResource("string:empty_saved_searches_title", "empty_saved_searches_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1430, 74),
      ))
    }

internal val Res.string.error_auction_not_found: StringResource by lazy {
      StringResource("string:error_auction_not_found", "error_auction_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1505, 87),
      ))
    }

internal val Res.string.error_loading: StringResource by lazy {
      StringResource("string:error_loading", "error_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1661, 49),
      ))
    }

internal val Res.string.error_loading_favorites: StringResource by lazy {
      StringResource("string:error_loading_favorites", "error_loading_favorites", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1593, 67),
      ))
    }

internal val Res.string.error_unknown: StringResource by lazy {
      StringResource("string:error_unknown", "error_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1711, 45),
      ))
    }

internal val Res.string.icon_auction_id: StringResource by lazy {
      StringResource("string:icon_auction_id", "icon_auction_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1757, 39),
      ))
    }

internal val Res.string.icon_boe_id: StringResource by lazy {
      StringResource("string:icon_boe_id", "icon_boe_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1797, 27),
      ))
    }

internal val Res.string.icon_catastral: StringResource by lazy {
      StringResource("string:icon_catastral", "icon_catastral", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1825, 42),
      ))
    }

internal val Res.string.icon_email: StringResource by lazy {
      StringResource("string:icon_email", "icon_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1868, 26),
      ))
    }

internal val Res.string.icon_end: StringResource by lazy {
      StringResource("string:icon_end", "icon_end", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1895, 20),
      ))
    }

internal val Res.string.icon_expediente: StringResource by lazy {
      StringResource("string:icon_expediente", "icon_expediente", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1916, 39),
      ))
    }

internal val Res.string.icon_location: StringResource by lazy {
      StringResource("string:icon_location", "icon_location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1956, 37),
      ))
    }

internal val Res.string.icon_name: StringResource by lazy {
      StringResource("string:icon_name", "icon_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1994, 25),
      ))
    }

internal val Res.string.icon_phone: StringResource by lazy {
      StringResource("string:icon_phone", "icon_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2020, 30),
      ))
    }

internal val Res.string.icon_start: StringResource by lazy {
      StringResource("string:icon_start", "icon_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2051, 26),
      ))
    }

internal val Res.string.image_placeholder_text: StringResource by lazy {
      StringResource("string:image_placeholder_text", "image_placeholder_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2078, 38),
      ))
    }

internal val Res.string.label_active: StringResource by lazy {
      StringResource("string:label_active", "label_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2117, 28),
      ))
    }

internal val Res.string.label_additional: StringResource by lazy {
      StringResource("string:label_additional", "label_additional", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2146, 56),
      ))
    }

internal val Res.string.label_appraisal: StringResource by lazy {
      StringResource("string:label_appraisal", "label_appraisal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2203, 35),
      ))
    }

internal val Res.string.label_auction_type: StringResource by lazy {
      StringResource("string:label_auction_type", "label_auction_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2239, 46),
      ))
    }

internal val Res.string.label_auction_value: StringResource by lazy {
      StringResource("string:label_auction_value", "label_auction_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2286, 47),
      ))
    }

internal val Res.string.label_bid_step: StringResource by lazy {
      StringResource("string:label_bid_step", "label_bid_step", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2334, 42),
      ))
    }

internal val Res.string.label_charges: StringResource by lazy {
      StringResource("string:label_charges", "label_charges", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2377, 29),
      ))
    }

internal val Res.string.label_claimed_amount: StringResource by lazy {
      StringResource("string:label_claimed_amount", "label_claimed_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2407, 52),
      ))
    }

internal val Res.string.label_created_at: StringResource by lazy {
      StringResource("string:label_created_at", "label_created_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2460, 40),
      ))
    }

internal val Res.string.label_current_bid: StringResource by lazy {
      StringResource("string:label_current_bid", "label_current_bid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2501, 41),
      ))
    }

internal val Res.string.label_deposit: StringResource by lazy {
      StringResource("string:label_deposit", "label_deposit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2543, 33),
      ))
    }

internal val Res.string.label_email: StringResource by lazy {
      StringResource("string:label_email", "label_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2577, 47),
      ))
    }

internal val Res.string.label_lots_count: StringResource by lazy {
      StringResource("string:label_lots_count", "label_lots_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2625, 40),
      ))
    }

internal val Res.string.label_min_bid: StringResource by lazy {
      StringResource("string:label_min_bid", "label_min_bid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2666, 37),
      ))
    }

internal val Res.string.label_new_auction: StringResource by lazy {
      StringResource("string:label_new_auction", "label_new_auction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2704, 33),
      ))
    }

internal val Res.string.label_no_min_bid: StringResource by lazy {
      StringResource("string:label_no_min_bid", "label_no_min_bid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2738, 48),
      ))
    }

internal val Res.string.label_password: StringResource by lazy {
      StringResource("string:label_password", "label_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2787, 38),
      ))
    }

internal val Res.string.label_possession: StringResource by lazy {
      StringResource("string:label_possession", "label_possession", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2826, 52),
      ))
    }

internal val Res.string.label_procedure_type: StringResource by lazy {
      StringResource("string:label_procedure_type", "label_procedure_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2879, 56),
      ))
    }

internal val Res.string.label_province: StringResource by lazy {
      StringResource("string:label_province", "label_province", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2936, 34),
      ))
    }

internal val Res.string.label_registry: StringResource by lazy {
      StringResource("string:label_registry", "label_registry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2971, 34),
      ))
    }

internal val Res.string.label_results_count: StringResource by lazy {
      StringResource("string:label_results_count", "label_results_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3006, 47),
      ))
    }

internal val Res.string.label_type: StringResource by lazy {
      StringResource("string:label_type", "label_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3054, 26),
      ))
    }

internal val Res.string.label_user: StringResource by lazy {
      StringResource("string:label_user", "label_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3081, 30),
      ))
    }

internal val Res.string.label_visitable: StringResource by lazy {
      StringResource("string:label_visitable", "label_visitable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3112, 35),
      ))
    }

internal val Res.string.loading: StringResource by lazy {
      StringResource("string:loading", "loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3148, 31),
      ))
    }

internal val Res.string.login_required_favorites: StringResource by lazy {
      StringResource("string:login_required_favorites", "login_required_favorites", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3180, 164),
      ))
    }

internal val Res.string.login_required_saved_searches: StringResource by lazy {
      StringResource("string:login_required_saved_searches", "login_required_saved_searches", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3345, 145),
      ))
    }

internal val Res.string.month_april: StringResource by lazy {
      StringResource("string:month_april", "month_april", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3491, 27),
      ))
    }

internal val Res.string.month_august: StringResource by lazy {
      StringResource("string:month_august", "month_august", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3519, 28),
      ))
    }

internal val Res.string.month_december: StringResource by lazy {
      StringResource("string:month_december", "month_december", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3548, 34),
      ))
    }

internal val Res.string.month_february: StringResource by lazy {
      StringResource("string:month_february", "month_february", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3583, 34),
      ))
    }

internal val Res.string.month_january: StringResource by lazy {
      StringResource("string:month_january", "month_january", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3618, 29),
      ))
    }

internal val Res.string.month_july: StringResource by lazy {
      StringResource("string:month_july", "month_july", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3648, 26),
      ))
    }

internal val Res.string.month_june: StringResource by lazy {
      StringResource("string:month_june", "month_june", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3675, 26),
      ))
    }

internal val Res.string.month_march: StringResource by lazy {
      StringResource("string:month_march", "month_march", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3702, 27),
      ))
    }

internal val Res.string.month_may: StringResource by lazy {
      StringResource("string:month_may", "month_may", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3730, 25),
      ))
    }

internal val Res.string.month_november: StringResource by lazy {
      StringResource("string:month_november", "month_november", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3756, 34),
      ))
    }

internal val Res.string.month_october: StringResource by lazy {
      StringResource("string:month_october", "month_october", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3791, 33),
      ))
    }

internal val Res.string.month_september: StringResource by lazy {
      StringResource("string:month_september", "month_september", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3825, 39),
      ))
    }

internal val Res.string.nav_favorites: StringResource by lazy {
      StringResource("string:nav_favorites", "nav_favorites", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3865, 33),
      ))
    }

internal val Res.string.nav_home: StringResource by lazy {
      StringResource("string:nav_home", "nav_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3899, 24),
      ))
    }

internal val Res.string.nav_profile: StringResource by lazy {
      StringResource("string:nav_profile", "nav_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3924, 27),
      ))
    }

internal val Res.string.nav_saved: StringResource by lazy {
      StringResource("string:nav_saved", "nav_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3952, 29),
      ))
    }

internal val Res.string.option_all: StringResource by lazy {
      StringResource("string:option_all", "option_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4019, 26),
      ))
    }

internal val Res.string.option_all_masculine: StringResource by lazy {
      StringResource("string:option_all_masculine", "option_all_masculine", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3982, 36),
      ))
    }

internal val Res.string.option_others: StringResource by lazy {
      StringResource("string:option_others", "option_others", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4046, 29),
      ))
    }

internal val Res.string.option_properties: StringResource by lazy {
      StringResource("string:option_properties", "option_properties", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4076, 37),
      ))
    }

internal val Res.string.option_vehicles: StringResource by lazy {
      StringResource("string:option_vehicles", "option_vehicles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4114, 39),
      ))
    }

internal val Res.string.profile_item_help: StringResource by lazy {
      StringResource("string:profile_item_help", "profile_item_help", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4154, 45),
      ))
    }

internal val Res.string.profile_item_my_data: StringResource by lazy {
      StringResource("string:profile_item_my_data", "profile_item_my_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4200, 40),
      ))
    }

internal val Res.string.profile_item_notifications: StringResource by lazy {
      StringResource("string:profile_item_notifications", "profile_item_notifications", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4241, 54),
      ))
    }

internal val Res.string.profile_item_privacy: StringResource by lazy {
      StringResource("string:profile_item_privacy", "profile_item_privacy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4296, 60),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("btn_accept", Res.string.btn_accept)
  map.put("btn_apply_filters", Res.string.btn_apply_filters)
  map.put("btn_back", Res.string.btn_back)
  map.put("btn_close", Res.string.btn_close)
  map.put("btn_filter", Res.string.btn_filter)
  map.put("btn_go_to_profile", Res.string.btn_go_to_profile)
  map.put("btn_google_signin", Res.string.btn_google_signin)
  map.put("btn_login", Res.string.btn_login)
  map.put("btn_logout", Res.string.btn_logout)
  map.put("btn_next", Res.string.btn_next)
  map.put("btn_remove_filter", Res.string.btn_remove_filter)
  map.put("btn_save_search", Res.string.btn_save_search)
  map.put("btn_share", Res.string.btn_share)
  map.put("btn_signup", Res.string.btn_signup)
  map.put("btn_start", Res.string.btn_start)
  map.put("btn_view_boe", Res.string.btn_view_boe)
  map.put("default_saved_search_title", Res.string.default_saved_search_title)
  map.put("default_search_title", Res.string.default_search_title)
  map.put("desc_ai_verified", Res.string.desc_ai_verified)
  map.put("desc_delete_search", Res.string.desc_delete_search)
  map.put("desc_filter_icon", Res.string.desc_filter_icon)
  map.put("desc_location_icon", Res.string.desc_location_icon)
  map.put("desc_map_location", Res.string.desc_map_location)
  map.put("desc_remove_favorite", Res.string.desc_remove_favorite)
  map.put("desc_save_search", Res.string.desc_save_search)
  map.put("desc_search_bar", Res.string.desc_search_bar)
  map.put("desc_splash_screen_logo", Res.string.desc_splash_screen_logo)
  map.put("desc_toggle_favorite", Res.string.desc_toggle_favorite)
  map.put("empty_favorites_subtitle", Res.string.empty_favorites_subtitle)
  map.put("empty_favorites_title", Res.string.empty_favorites_title)
  map.put("empty_saved_searches_title", Res.string.empty_saved_searches_title)
  map.put("error_auction_not_found", Res.string.error_auction_not_found)
  map.put("error_loading", Res.string.error_loading)
  map.put("error_loading_favorites", Res.string.error_loading_favorites)
  map.put("error_unknown", Res.string.error_unknown)
  map.put("icon_auction_id", Res.string.icon_auction_id)
  map.put("icon_boe_id", Res.string.icon_boe_id)
  map.put("icon_catastral", Res.string.icon_catastral)
  map.put("icon_email", Res.string.icon_email)
  map.put("icon_end", Res.string.icon_end)
  map.put("icon_expediente", Res.string.icon_expediente)
  map.put("icon_location", Res.string.icon_location)
  map.put("icon_name", Res.string.icon_name)
  map.put("icon_phone", Res.string.icon_phone)
  map.put("icon_start", Res.string.icon_start)
  map.put("image_placeholder_text", Res.string.image_placeholder_text)
  map.put("label_active", Res.string.label_active)
  map.put("label_additional", Res.string.label_additional)
  map.put("label_appraisal", Res.string.label_appraisal)
  map.put("label_auction_type", Res.string.label_auction_type)
  map.put("label_auction_value", Res.string.label_auction_value)
  map.put("label_bid_step", Res.string.label_bid_step)
  map.put("label_charges", Res.string.label_charges)
  map.put("label_claimed_amount", Res.string.label_claimed_amount)
  map.put("label_created_at", Res.string.label_created_at)
  map.put("label_current_bid", Res.string.label_current_bid)
  map.put("label_deposit", Res.string.label_deposit)
  map.put("label_email", Res.string.label_email)
  map.put("label_lots_count", Res.string.label_lots_count)
  map.put("label_min_bid", Res.string.label_min_bid)
  map.put("label_new_auction", Res.string.label_new_auction)
  map.put("label_no_min_bid", Res.string.label_no_min_bid)
  map.put("label_password", Res.string.label_password)
  map.put("label_possession", Res.string.label_possession)
  map.put("label_procedure_type", Res.string.label_procedure_type)
  map.put("label_province", Res.string.label_province)
  map.put("label_registry", Res.string.label_registry)
  map.put("label_results_count", Res.string.label_results_count)
  map.put("label_type", Res.string.label_type)
  map.put("label_user", Res.string.label_user)
  map.put("label_visitable", Res.string.label_visitable)
  map.put("loading", Res.string.loading)
  map.put("login_required_favorites", Res.string.login_required_favorites)
  map.put("login_required_saved_searches", Res.string.login_required_saved_searches)
  map.put("month_april", Res.string.month_april)
  map.put("month_august", Res.string.month_august)
  map.put("month_december", Res.string.month_december)
  map.put("month_february", Res.string.month_february)
  map.put("month_january", Res.string.month_january)
  map.put("month_july", Res.string.month_july)
  map.put("month_june", Res.string.month_june)
  map.put("month_march", Res.string.month_march)
  map.put("month_may", Res.string.month_may)
  map.put("month_november", Res.string.month_november)
  map.put("month_october", Res.string.month_october)
  map.put("month_september", Res.string.month_september)
  map.put("nav_favorites", Res.string.nav_favorites)
  map.put("nav_home", Res.string.nav_home)
  map.put("nav_profile", Res.string.nav_profile)
  map.put("nav_saved", Res.string.nav_saved)
  map.put("option_all", Res.string.option_all)
  map.put("option_all_masculine", Res.string.option_all_masculine)
  map.put("option_others", Res.string.option_others)
  map.put("option_properties", Res.string.option_properties)
  map.put("option_vehicles", Res.string.option_vehicles)
  map.put("profile_item_help", Res.string.profile_item_help)
  map.put("profile_item_my_data", Res.string.profile_item_my_data)
  map.put("profile_item_notifications", Res.string.profile_item_notifications)
  map.put("profile_item_privacy", Res.string.profile_item_privacy)
}
